import { lazy } from 'react';

const LazyShoppingCartDrawer = lazy(() => import('screens/shopping-cart-drawer'));

export default LazyShoppingCartDrawer;
